import axios from "axios";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


// 관리자 목록 가져오기
export const fetchAdminList = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
          Accept: "application/json",
      },
    });

    if (Array.isArray(response.data.admin)) {
      return response.data.admin;
    } else {
      console.warn("admin 목록이 배열이 아님:", response.data.admin);
      return [];
    }
  } catch (error) {
    console.error("관리자 목록 불러오기 실패:", error);
    return [];
  }
};

// 관리자 삭제
export const deleteAdmin = async (adminId, token) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/admin/${adminId}`,
      {
        headers: { Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
          Accept: "application/json", },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};